var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.980591 2.48315C0.770591 2.48315 0.560591 2.56315 0.39059 2.69315C-0.0494095 3.03315 -0.129409 3.66315 0.210591 4.09315V4.10315L5.52059 10.9032V16.8932L7.81059 19.1932C8.20059 19.5832 8.84059 19.5832 9.23059 19.1932C9.62059 18.8032 9.62059 18.1632 9.23059 17.7732L7.52059 16.0732V10.2132L1.79059 2.87315C1.69486 2.75002 1.57191 2.65073 1.43138 2.58306C1.29084 2.5154 1.13655 2.4812 0.980591 2.48315ZM13.5206 9.48315V17.3632C13.5606 17.6632 13.4606 17.9832 13.2306 18.1932C13.1381 18.2859 13.0282 18.3594 12.9072 18.4096C12.7862 18.4598 12.6566 18.4856 12.5256 18.4856C12.3946 18.4856 12.2649 18.4598 12.144 18.4096C12.023 18.3594 11.9131 18.2859 11.8206 18.1932L9.81059 16.1832C9.70152 16.0765 9.6186 15.9461 9.56829 15.8022C9.51798 15.6582 9.50166 15.5045 9.52059 15.3532V9.48315H9.49059L3.73059 2.10315C3.5682 1.89468 3.49492 1.63041 3.52678 1.36808C3.55863 1.10576 3.69303 0.866701 3.90059 0.703154C4.09059 0.563154 4.30059 0.483154 4.52059 0.483154H18.5206C18.7406 0.483154 18.9506 0.563154 19.1406 0.703154C19.3482 0.866701 19.4825 1.10576 19.5144 1.36808C19.5463 1.63041 19.473 1.89468 19.3106 2.10315L13.5506 9.48315H13.5206Z",
    fill: "#969696"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.6b1de40b14ef76b65d4efe3193e88ca5.svg";
export { ForwardRef as ReactComponent };